import { useEffect, useMemo, useState } from 'react';

import { PowerOfAttorneyFormValues } from '@/lib/types/power-of-attorney.ts';
import { buildDocumentHtml, loadDocumentHtmlTemplate } from '@/lib/utils/file.ts';
import { escapeHtml } from '@/lib/utils/stringFormat.ts';

const POWER_OF_ATTORNEY_TEMPLATE_PATH = '/templates/power-of-attorney-a4.html';

const createPowerOfAttorneyTemplateMap = (formValues: PowerOfAttorneyFormValues): Record<string, string> => {
  return {
    principalName: escapeHtml(formValues.principalName),
    principalRrn: escapeHtml(formValues.principalRrn),
    principalAddress: escapeHtml(formValues.principalAddress),
    issuedDate: escapeHtml(formValues.issuedDate),
    autographImage: formValues.autographDataUrl ? `<img class="autograph-image" src="${formValues.autographDataUrl}" alt="서명" />` : ''
  };
};

export const usePowerOfAttorneyDocumentHtml = (formValues: PowerOfAttorneyFormValues) => {
  const [template, setTemplate] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const loadTemplate = async () => {
      try {
        const htmlTemplate = await loadDocumentHtmlTemplate(POWER_OF_ATTORNEY_TEMPLATE_PATH);
        setTemplate(htmlTemplate);
        setErrorMessage('');
      } catch (error) {
        setErrorMessage(error instanceof Error ? error.message : '위임장 템플릿을 불러오지 못했습니다.');
      }
    };

    void loadTemplate();
  }, []);

  const documentHtml = useMemo(() => {
    if (!template) {
      return '';
    }

    return buildDocumentHtml(template, createPowerOfAttorneyTemplateMap(formValues));
  }, [formValues, template]);

  return {
    documentHtml,
    errorMessage
  };
};
